<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="wrapper">
      <div class="row">
        <div class="col-3">
          <div class="label">โครงการ</div>
          <project-select v-model="query.project"></project-select>
        </div>
        <div class="col-2">
          <div class="label">บ้านเลขที่</div>
          <el-input v-model="query.homeNo" />
        </div>
        <div class="col-3">
          <div class="label">ชื่อลูกค้า</div>
          <el-input v-model="query.customerName" />
        </div>
        <div class="col-2">
          <div class="label">สถานะการติดต่อ</div>
          <el-select v-model="query.contactStatus" clearable>
            <el-option
              v-for="t in leadHomeStatusMapper"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="search">
        <div class="text-right mt-2 pr-2">
          <sc-button variant="warning" @click="handleClickClear"
            >clear</sc-button
          >
        </div>
        <div class="mt-2">
          <sc-button variant="primary" @click="handleClickSearch"
            >ค้นหา</sc-button
          >
        </div>
      </div>
      <div>
        <div class="text-center" v-if="!total">ไม่มีข้อมูล</div>
        <div v-if="total">
          <p class="mb-1 mt-2">{{ totalCount }}</p>
          <div class="lead-list-row header">
            <div class="cell">โครงการ</div>
            <div class="cell">บ้านเลขที่</div>
            <div class="cell">ชื่อลูกค้า</div>
            <div class="cell">แพ็กเกจที่ขาย</div>
            <div class="cell">ผู้รับผิดชอบการขาย</div>
            <div class="cell status">สถานะการขาย</div>
            <div class="cell status">หมายเหตุ</div>
          </div>
          <div class="mb-4">
            <router-link
              class="lead-list-row"
              v-for="home in homelist"
              :key="home.id"
              :to="home.route"
            >
              <div class="cell">{{ home.projectCode }}</div>
              <div class="cell">{{ home.homeId }}</div>
              <div class="cell">{{ home.userName }}</div>
              <div>
                <div
                  class="cell"
                  v-for="(pack, index) in home.packagePurchases"
                  :key="index"
                >{{ pack }}
                </div>
              </div>
              <div class="cell">{{ home.adminName }}</div>
              <div class="cell lead-status-badge" :class="home.statusClassList">
                {{ home.statusTH }}
              </div>
              <div class="cell status">{{ home.remark }}</div>
            </router-link>
          </div>
          <div class="text-right">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page="+query.page"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../../../lib/components/PageWrapper";
import { Input, Pagination, Select, Option } from "element-ui";
import DatePicker from "@/lib/components/DatePicker";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import ProjectSelect from "@/lib/components/ProjectSelect";
import { leadHomeManagementStatusTH, leadHomeStatusMapper } from "@/lib/mapper";

export default {
  components: {
    PageWrapper,
    "el-input": Input,
    DatePicker,
    ScButton,
    ProjectSelect,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
  },
  name: "LeadManagementHomeCallCenterPage",
  data() {
    const pageWrapper = {
      title: "ข้อมูล Lead",
      hasPad: true,
    };

    const query = {
      project: null,
      homeNo: null,
      customerName: null,
      contactStatus: null,
      page: 1,
    };

    return {
      pageWrapper,
      query,
      total: 1,
      homelist: [],
      canBookingLead: false
    };
  },
  computed: {
    totalCount() {
      const limit = 15;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.homelist.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = +this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    leadHomeStatusMapper() {
      return leadHomeStatusMapper;
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setup();
    },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      this.query = {
        project: this.$route.query.project || null,
        homeNo: this.$route.query.homeNo || null,
        customerName: this.$route.query.customerName || null,
        contactStatus: this.$route.query.contactStatus || null,
        page: this.$route.query.page || 1,
      };
    },
    setupData() {
      this.setupLeadHomeList();
    },
    async setupLeadHomeList() {
      const {
        home_count: homeCount,
        lead_homes: leadHomes,
        name,
        can_booking_lead_home: canBookingLeadHome
      } = await this.fetchData();

      this.canBookingLead = canBookingLeadHome;
      const homelist = leadHomes
        && leadHomes.length > 0
        && leadHomes.map((leadHome) => {
        const id = leadHome.id;
        const projectCode = leadHome.project_code || "";
        const homeId = leadHome.home_no || "";
        const userName = leadHome.user_name || "";
        const packagePurchases = leadHome.packages && leadHome.packages.length > 0
          ? leadHome.packages.map((pack) => {
            const packageName = `${pack.name}(${pack.id})`;
            const quantity = `จำนวน ${pack.quantity} แพ็กเกจ`;

            return `- ${packageName}\n${quantity}`;
          })
          : null;

        const adminName = leadHome.admin_name || "";
        const status = leadHome.status || "";
        const remark = leadHome.remark || "";
        const route = { name: "LeadManagementContactPage", params: { id } };
        const statusClassList = [status];
        const statusTH = leadHomeManagementStatusTH[status];

        return {
          projectCode,
          homeId,
          userName,
          packagePurchases,
          adminName,
          statusTH,
          remark,
          route,
          statusClassList,
        };
      });

      this.homelist = homelist;
      this.total = homeCount;
    },
    async fetchData() {
      const params = {
        project_id:
          this.query.project && this.query.project.projectId
            ? this.query.project.projectId
            : null,
        home_id: this.query.homeNo || null,
        customer_name: this.query.customerName || null,
        status: this.query.contactStatus || null,
        page: this.query.page || null,
      };

      try {
        const response = await baanRueJaiClient.admin.lead.searchAllHomeList(params);

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
    handleClickClear() {
      this.query = {
        project: null,
        homeNo: null,
        customerName: null,
        contactStatus: null,
      };
    },
    handleClickSearch() {
      const query = {
        project: this.query.project,
        homeNo: this.query.homeNo,
        customerName: this.query.customerName,
        contactStatus: this.query.contactStatus,
        page: this.query.page,
      };

      this.$router.push({ query });
    },
    handleCurrentChange(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router.push({ query });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";
.wrapper {
  padding: ($space / 2) $space;
}

.lead-list-row {
  display: grid;
  grid-gap: $space;
  grid-template-columns: 180px 80px 150px 300px 150px 150px 150px;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    color: #999;
    font-size: 14px;
  }

  > .status {
    text-align: center;
  }
}

.search {
  display: grid;
  grid-template-columns: 94% auto;
  border-bottom: $border;
}

.link {
  display: inline-block;
  opacity: 1;

  &.back-page {
    font-weight: normal;
    color: #999;
    font-size: 20px;
  }

  &.name {
    font-weight: bold;
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/lead-management/pages/LeadManagementHomeCallCenterPage.vue